import React, { useState, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { superAxiosRequest } from 'axiosApi'
import { localisationMaster } from 'Localisation/Localisation'
import { timeConverter } from 'components/ContentBox/Online-schedule/components/functions'
import swal from 'sweetalert'
import style from './Tests.module.scss'
import TestResult from 'components/Modules/Groups/components/TestResults/TestResult/TestResult'
import { ReactComponent as EmptyData } from 'components/ContentBox/img/empty.svg'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalization from 'hooks/useLocalization'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import AddingPersonalTestResultsModal from '../../components/TestResults/TestResultsModals/AddingPersonalTestResultsModal'
import Stores from 'Stores'
import asideModalStore from 'Stores/asideModalStore'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'

const Tests = (props) => {
  const [searchText, setSearchText] = useState('')
  const [testResults, setTestResults] = useState([])
  const [categories, setCategories] = useState([])
  const [students, setStudents] = useState([])

  const id = props.match.params.id
  const [filter, updateFilter] = useLocalStorageFilter()
  const { setTextValues, changeTextValue, filterTextValues } = AsideFilterStore

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'group_tests',
    dict: {
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      adding_personal_test_results: 'Adding personal test results',
      tests: 'Tests',
      general: 'General',
      total: 'Total',
      yr: 'ж.',
    },
  })

  const onBeforeUpdate = (formData) => {
    return {
      ...formData,
    }
  }

  const handleSearchClear = () => {
    setSearchText('')
    const { student, ...obj } = filter
    updateFilter({ ...obj, student_name: '' })
    setTextValues(
      filterTextValues.filter((field) => field.key !== 'student_name'),
    )
  }

  const onAfterFinishedTestUpdate = (data) => {
    setTestResults(
      testResults.map((result) => (result?.id === data?.id ? data : result)),
    )
  }

  let ms = (isFinished) => {
    return {
      modalBodyComponent: () => (
        <AddingPersonalTestResultsModal
          isSmallForm={isFinished}
          students={(students || []).map((item) => ({
            ...item,
            full_name: Stores.transliterate(item.full_name),
            father_name: Stores.transliterate(item.father_name),
            last_name: Stores.transliterate(item.last_name),
          }))}
          categories={categories}
        />
      ),
      data: 'json',
      button: translate?.save,
      link: 'groups/interim_result_tests',
      title: translate?.adding_personal_test_results,
      type: 'groupTestResult',
      onBeforeSubmit: onBeforeUpdate,
      onSubmitSuccess: (data) => {
        setTestResults([...data?.interim, ...data?.test_results])
      },
      isResponsive: true,
      valid: {
        category: 'required',
        student: 'required',
        test: 'required',
        test_scores: 'required',
      },
    }
  }

  const menu = [
    { name: translate?.edit, action: 'edit' },
    { name: translate?.delete, action: 'delete' },
  ]

  const actions = (action, e, item, isFinished) => {
    switch (action) {
      case 'edit':
        const initialMs = ms(isFinished)
        let finalMs = {
          ...initialMs,
          is_put: true,
          link: `${initialMs.link}/${item?.id}`,
        }

        if (isFinished) {
          finalMs = {
            ...finalMs,
            valid: {},
            link: `study/student_test_result/${item?.id}`,
            onSubmitSuccess: onAfterFinishedTestUpdate,
          }
        }

        asideModalStore.activity(finalMs, {
          ...item,
          group: +props.gid,
          teacher: item?.teacher?.id,
          student: item?.student?.id,
        })
        break
      case 'delete':
        swal({
          title: `Вы действительно хотите удалить "${item.test}, ${item.student.full_name}" за  ${timeConverter(item.date, 'clean_data')} г.?`,
          text: 'Восстановить удаленные данные будет невозможно.',
          icon: 'warning',
          buttons: [
            localisationMaster('button_2', 'alert'),
            localisationMaster('button_1', 'alert'),
          ],
        }).then((okay) => {
          const apiCfg = {
            method: 'delete',
            link: `groups/interim_result_tests/${item.id}`,
          }
          superAxiosRequest(apiCfg).then(({ data }) => {
            setTestResults([...data?.interim, ...data?.test_results])
          })
        })
        break

      default:
        break
    }
  }

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: `study/test_result_by_group/${id}`,
      params: {
        ...filter,
      },
    })
      .then(({ data }) => {
        setTestResults([...data?.interim, ...data?.test_results])
      })
      .catch((error) => {
        console.error('Error fetching group:', error)
      })

    superAxiosRequest({
      method: 'get',
      link: `groups/employee_group/${id}`,
      params: {
        ...filter,
      },
    })
      .then(({ data }) => {
        setStudents(data?.students)
      })
      .catch((error) => {
        console.error('Error fetching students:', error)
      })

    superAxiosRequest({
      method: 'get',
      link: 'study/study_category',
    })
      .then(({ data }) => {
        setCategories(data || [])
      })
      .catch((error) => {
        console.error('Error fetching categories:', error)
      })
  }, [id, filter])

  const groupedStudents = useMemo(() => {
    const result = testResults?.reduce((groups, element) => {
      const studentId = element?.student?.id
      if (!groups[studentId]) {
        groups[studentId] = {
          student: { ...element.student },
          data: [],
        }
      }
      groups[studentId].data.push(element)
      return groups
    }, {})

    return Object.values(result).sort((a, b) => {
      const fullNameA =
        `${a?.student?.last_name} ${a?.student?.first_name}`.toLowerCase()
      const fullNameB =
        `${b?.student?.last_name} ${b?.student?.first_name}`.toLowerCase()
      return fullNameA.localeCompare(fullNameB)
    })
  }, [testResults])

  return (
    <div className={style.testsGroupContainer}>
      {/* TODO maybe needed in the future <PageHeader title={`${tests.group?.number} - ${tests.group?.name}`}/>*/}
      <PageHeader title={id} />
      <div className={style.search}>
        <SearchBooks
          onSearch={(text) => {
            updateFilter({ ...filter, student_name: text })
            changeTextValue('student_name', {
              key: 'student_name',
              label: 'Student',
              value: text,
            })
          }}
          onClear={handleSearchClear}
          translate={translate}
          placeholder={'Search by student name...'}
          value={filter?.student_name || ''}
          isFilterHidden={true}
        />
        {filter?.student_name && (
          <FilterTextValues onDelete={handleSearchClear} />
        )}
      </div>
      <div className={style.testsGroup}>
        <div className={style.containerForTests}>
          <div className={style.nameTest}>Tests</div>
          {groupedStudents?.length > 0 ? (
            <div>
              {groupedStudents?.map((item, index) => {
                return (
                  <TestResult
                    item={item}
                    key={index}
                    menu={menu}
                    actions={actions}
                    translate={translate}
                    stats={null}
                    showAllTests
                  />
                )
              })}
            </div>
          ) : (
            <div className={style.empty}>
              <EmptyData />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default observer(Tests)
